import { DEFAULT_CALENDAR_VISIBILITY } from '@/app/(main)/calendar/consts/storage-keys';
import { USER_SETTINGS_IDENTIFIERS } from '@/consts/user-settings';
import type { CalendarPreferences } from '@/types/calendarTypes';

export const CALENDAR_VISIBILITY_TOOGLES_IDENTIFIER = USER_SETTINGS_IDENTIFIERS.CALENDAR_VISIBILITY_TOOGLES;

export const DEFAULT_CALENDAR_PREFERENCES: CalendarPreferences = {
  view: 'day',
  visibility: {
    events: DEFAULT_CALENDAR_VISIBILITY.events,
    birthdays: DEFAULT_CALENDAR_VISIBILITY.birthdays,
    tasks: DEFAULT_CALENDAR_VISIBILITY.tasks,
  },
};
